// General
import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";

import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import Grid from "react-bootstrap/lib/Grid";
import Button from "react-bootstrap/lib/Button";

import s from "./ListPlaceStep1.css";
import bt from "../../components/commonStyle.css";

import Avatar from "../Avatar";
import update from "./update";

import messages from "../../locale/messages";

import BgImage from "/public/SiteImages/createListBg.svg";
import ListImage from "/public/SiteImages/talkingDogHome.svg";
import darkImage from "/public/SiteImages/darkIntro.svg";
import waveIcon from "/public/SiteIcons/waving-hand.png";
import importIcon from "/public/SiteIcons/importItems.svg";
import addIcon from "/public/SiteIcons/addListIcon.svg";
import ImportListingModal from "../ImportListingModal/ImportListingModal";
import { openImportListModal } from "../../actions/modalActions";
class ListIntro extends Component {
  static propTypes = {
    initialValues: PropTypes.object,
    hostDisplayName: PropTypes.string.isRequired,
    guestDisplayName: PropTypes.string,
    nextPage: PropTypes.any,
    hostPicture: PropTypes.string,
    guestPicture: PropTypes.string,
    userData: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
    }).isRequired,
    openImportListModal: PropTypes.any,
  };

  static defaultProps = {
    userData: {
      firstName: "",
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      roomType: [],
      personCapacity: [],
    };
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (listingFields != undefined) {
      this.setState({
        roomType: listingFields.roomType,
        personCapacity: listingFields.personCapacity,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    if (listingFields != undefined) {
      this.setState({
        roomType: listingFields.roomType,
        personCapacity: listingFields.personCapacity,
      });
    }
  }

  render() {
    const {
      openImportListModal,
      nextPage,
      userData,
      hostPicture,
      hostDisplayName,
      guestDisplayName,
    } = this.props;
    return (
      <div className={s.listIntroBgSection}>
        <ImportListingModal />
        <div
          className={cx(s.listIntroBg, "listIntroBgImage")}
          style={{ backgroundImage: `url(${BgImage})` }}
        ></div>
        <Grid fluid className={s.listIntroContainer}>
          <div className={s.userRight}>
            <Avatar
              isUser
              title={guestDisplayName}
              className={s.profileImage}
            />
          </div>
          <h3 className={s.listIntroTitle}>
            <img src={waveIcon} className={s.waveCss} />{" "}
            <FormattedMessage {...messages.hi} />,
            <span className={s.userNameColor}>{userData.firstName}!</span>
          </h3>
          <h3 className={cx(s.listIntroTitle, s.spaceTop4, s.spaceBottom20)}>
            <FormattedMessage {...messages.letYouGetReady} />.
          </h3>
          <Button
            className={cx(
              s.button,
              bt.btnPrimary,
              bt.btnLarge,
              s.space5,
              s.spaceTop2,
              s.textBold,
              s.mr20
            )}
            onClick={() => nextPage("room")}
          >
            <img src={addIcon} className={cx(s.plusIcon, "addPlusIcon")} />
            &nbsp;
            <FormattedMessage {...messages.createListingButton} />
          </Button>
          <Button
            onClick={openImportListModal}
            className={cx(
              s.button,
              bt.btnLarge,
              s.space5,
              s.spaceTop2,
              s.textBold,
              bt.importListing
            )}
          >
            <img src={importIcon} className={cx(s.plusIcon, "addPlusIcon")} />
            <FormattedMessage {...messages.importListing} />
          </Button>
          <img
            className={cx(s.userDescriptionImage, "lightModeImg")}
            src={ListImage}
          />
          <img
            className={cx(s.userDescriptionImage, "darkModeImg")}
            src={darkImage}
          />
        </Grid>
      </div>
    );
  }
}

ListIntro = reduxForm({
  form: "ListPlaceStep1", // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: update,
})(ListIntro);

const mapState = (state) => ({
  userData: state.account.data,
  listingFields: state.listingFields.data,
});

const mapDispatch = {
  openImportListModal,
};

export default injectIntl(
  withStyles(s, bt)(connect(mapState, mapDispatch)(ListIntro))
);
